<template>
  <div>
  <v-flex xs10 offset-xs1>
    <div class="fl" style="width: 100%">
      <div class="golden-left">
        <h1 class="mb-4">{{ 'report-of-sickness.new-report-of-sickness' | translate }}</h1>
      </div>
    </div>

    <div class="fl" style="width: 100%">
      <div class="golden-left">
        <!-- <SelectEmployeeForm v-if="activeView === views.SelectEmployeeForm" />
        <NewReportOfSicknessForm v-if="activeView === views.NewReportOfSicknessForm" />
        <NewReportOfSicknessConfirmation v-if="activeView === views.NewReportOfSicknessConfirmation" /> -->
      </div>

      <div class="golden-right">
        <!-- <ProgressStepper :steps="this.steps" :sticky="320" /> -->
      </div>
    </div>
  </v-flex>
</div>
</template>

<script>
// import { mapGetters, mapActions } from 'vuex';

// import ProgressStepper from '@aevitae/aevitaeui/1_molecules/stepper/ProgressStepper.vue';

export default {
  name: 'ReportsOfSicknessImport',
  components: {
    // ProgressStepper
  }
};
</script>

<style>

</style>
